module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ranking"
  }, [_c('div', {
    staticClass: "taber"
  }, [_c('touch', {
    staticClass: "tab",
    class: {
      active: _vm.isPersonRanking()
    },
    on: {
      "tap": _vm.showPersonRanking
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._v("个人累计捐赠")])]), _vm._v(" "), _c('touch', {
    staticClass: "tab",
    class: {
      active: _vm.isGroupRanking()
    },
    on: {
      "tap": _vm.showGroupRanking
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._v("高校累计捐赠")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "contenter"
  }, [_c('div', {
    staticClass: "content",
    class: {
      active: _vm.isPersonRanking()
    }
  }, [_c('person-ranking')], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      active: _vm.isGroupRanking()
    }
  }, [_c('group-ranking')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-16186976","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Ranking.vue
// module id = 198
// module chunks = 1